import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import Btn from 'components/Btn'
import { Menu } from 'assets/icons'
import { useDispatch } from 'react-redux'
import { showModal } from 'store/slices/miscSlice'
import AddUser from './AddUser'
import { UserValidation } from 'pages/Settings/validation'

export default withTranslation()(function Header({t}) {
  const [exportTable, setexportTable] = useState(true)
  // const { merchant } = useSelector(state => state.SettingsReducer)
  const dispatch = useDispatch()
  
  return (
    <div className="flex justify-between items-center w-full mb-5 p-3">
      <h1 className="text-xl font-bold text-secondary grow">{ t('settings.user_management.table_title') }</h1>

      <div className="lg:grid grid-cols-2 gap-3 hidden">
          <Btn 
            content={t('settings.user_management.add_account')}
            className="text-white bg-primary w-36 h-12 lg:col-span-2 rounded-xl"
            click={() => {
              dispatch(showModal({
                title: t('settings.user_management.add'),
                content: AddUser,
                validation: UserValidation,
                method: 'post',
                url: `merchants/users`,
                successMsg: t('settings.user_management.form.success')
              }))
            }}
          />
      </div>

      
      <div className="lg:w-[290px] flex justify-between relative lg:hidden">
        
        {/* <div className={`w-10 h-10 overflow-hidden border rounded-lg order-2 lg:order-1 ${exportTable ? 'border-primary' : '' }`}> */}
          <Btn
            content={() => <Menu classList="h-5" />}
            className={`w-10 h-10 overflow-hidden border rounded-lg order-2 lg:order-1 ${exportTable ? 'border-primary' : '' }`}
            click={ () => setexportTable(!exportTable) }
          />
        {/* </div> */}

        <ul className={`p-2 shadow-lg top-12 border w-[180px] right-0 absolute z-30 bg-white divide-y rounded-lg ${exportTable ? 'block' : 'hidden' }`}>
          <li className="p-2">{ t('settings.user_management.add_account') }</li>
        </ul>
      </div>
    </div>
  )
})
